import React, {
  useState,
  useEffect,
} from 'react';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Container,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Page from '../../../components/Layout/Page';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import BillEditForm from './BillEditForm';
import Header from './Header';
import billRequest from '../../../requests/api/bill';
import clientRequest from '../../../requests/api/client';
import useStyles from './styles';

function BillEditView(props) {
  const classes = useStyles();
  const isMountedRef = useIsMountedRef();
  const [bill, setBill] = useState({});
  const [clients, setClients] = useState([]);

  useEffect(() => {
    const getBill = async () => {
      const res = await billRequest.getBillById(props.match.params.id);
      const response = res.data;
      if (isMountedRef.current) {
        setBill(response.data.bill);
      }
    };
    const getAllClients = async () => {
      const response = await clientRequest.getAllClients();
      if (response.success) {
        const data = await response.data.data.clients;
        const arrayData = Object.values(data);
        setClients(arrayData);
      }
    };
    getAllClients();
    getBill();
    // eslint-disable-next-line
  }, [props]);

  if (!bill) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="Editar Factura"
    >
      <Container maxWidth="lg">
        <Header />
        <Box mt={3}>
          <BillEditForm bill={bill} clients={clients}/>
        </Box>
      </Container>
    </Page>
  );
}

BillEditView.propTypes = {
  match: PropTypes.any,
};

export default withRouter(BillEditView);
